import { useEffect } from 'react';

/**
 * Commits a collapse only after its exit animation has had `exitMs` to finish,
 * and un-commits immediately when the item can return. Each item in the
 * sidebar collapse cascade gates on the previous item's committed value, which
 * is what sequences the fold one item at a time.
 */
export function useCommitAfterCollapseExit(
  isCollapsed: boolean,
  commit: (isCommitted: boolean) => void,
  exitMs: number
): void {
  useEffect(() => {
    if (!isCollapsed) {
      commit(false);
      return;
    }
    const id = setTimeout(() => commit(true), exitMs);
    return () => clearTimeout(id);
  }, [isCollapsed, commit, exitMs]);
}
